import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "progressMessage"
};
var _hoisted_2 = {
  key: 0,
  "class": "progressContainer"
};
var _hoisted_3 = ["value"];
var _hoisted_4 = ["percent"];
import { isUniFrameWork } from "../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    content: {
      "default": function _default() {
        return {};
      }
    },
    messageItem: {
      "default": function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default"), props.messageItem.status === 'unSend' && props.messageItem.progress < 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [!_unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("progress", {
        key: 0,
        "class": "progress",
        value: props.messageItem.progress,
        max: "1"
      }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("progress", {
        key: 1,
        activeColor: "#006EFF",
        "class": "progressCommon",
        percent: Math.round(props.messageItem.progress * 100)
      }, null, 8, _hoisted_4))])) : _createCommentVNode("", true)]);
    };
  }
});